import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table } from 'semantic-ui-react';
import HasSomeRights from 'nallian-shared-ui/lib/layout/rights/HasSomeRights';
import { Icon, ConfirmModal } from 'nallian-shared-ui/lib/components';

const ORGANISATION_APP_RIGHTS = [
  'ORGANISATIONAPPS.MANAGE.ALL',
  'ORGANISATIONAPPS.MANAGE.ALL.EXCEPTSYSTEMORGS',
  'ORGANISATIONAPPS.MANAGE.ORGANISATION',
];

const AppSubscriptionFeature = ({
  forbidManageBecauseSystemOrg,
  organisationApp,
  feature,
  handleRemoveFeature,
}) => {
  const { t } = useTranslation();

  const onRemoveFeature = useCallback(
    () => handleRemoveFeature(undefined, { feature, organisationApp }),
    [handleRemoveFeature, organisationApp, feature]
  );

  return (
    <Table.Row>
      <Table.Cell>{feature.alias || feature.appInstallationFeature?.name}</Table.Cell>
      <Table.Cell>
        {feature.requiresSubscription ? t('subscriptionRequired') : t('noSubscriptionRequired')}
      </Table.Cell>
      <Table.Cell textAlign="right">
        {!forbidManageBecauseSystemOrg && (
          <HasSomeRights rights={ORGANISATION_APP_RIGHTS}>
            {feature.requiresSubscription && (
              <>
                <ConfirmModal
                  header={t('areYouSureYouWantToRemoveAppFeatureSubscription')}
                  cancelContent={t('cancel')}
                  confirmContent={t('confirm')}
                  confirmColor="red"
                  onConfirm={onRemoveFeature}
                  feature={feature}
                  organisationApp={organisationApp}
                  trigger={
                    <Icon
                      iconbutton
                      size="large"
                      name="close"
                      feature={feature}
                      organisationApp={organisationApp}
                    />
                  }
                />
              </>
            )}
          </HasSomeRights>
        )}
      </Table.Cell>
    </Table.Row>
  );
};

AppSubscriptionFeature.propTypes = {
  urlRoot: PropTypes.string.isRequired,
  organisationApp: PropTypes.object.isRequired,
  feature: PropTypes.object.isRequired,
  handleRemoveFeature: PropTypes.func.isRequired,
  forbidManageBecauseSystemOrg: PropTypes.bool.isRequired,
};

export default AppSubscriptionFeature;
